/* eslint-disable max-classes-per-file */
export class ApiError extends Error {
  name = 'ApiError';

  status: number;

  constructor(status: number, message?: string) {
    super(message);
    this.status = status;
  }
}

// 4xx
export class ClientError extends ApiError {
  name = 'ClientError';
}

export class BadRequestError extends ClientError {
  name = 'BadRequestError';

  constructor() {
    super(400, 'Bad Request');
  }
}

export class AuthorizationError extends ClientError {
  name = 'AuthorizationError';

  constructor() {
    super(403, 'Authorization failed');
  }
}

export class NotFoundError extends ClientError {
  name = 'NotFoundError';

  constructor() {
    super(404, 'Not Found');
  }
}

export type ValidationErrors = Record<string, string[]>;
export class ValidationError extends ClientError {
  name = 'ValidationError';

  validationErrors: ValidationErrors;

  constructor(validationErrors: ValidationErrors) {
    super(422, 'Validation failed');
    this.validationErrors = validationErrors;
  }
}

// 5xx
export class ServerError extends ApiError {
  name = 'ServerError';
}
export class InternalServerError extends ServerError {
  name = 'InternalServerError';

  constructor() {
    super(500, 'Internal Server Error');
  }
}
